import { useContext } from 'react';
import PropTypes from 'prop-types';
import i18nContext from 'components/i18n-context';
import { useApplicationContext } from 'contexts/ApplicationContext';
import { PAYMENT_PROVIDER } from 'components/constants';
import Loader from 'components/Loader';
import Button from 'uikit/Button/Button';
import { CustomDatePicker } from 'uikit/CustomDatePicker';
import { InputDropDown } from 'uikit/InputDropDown/InputDropDown';
import { InputDropDownSearch } from 'uikit/InputDropDown/InputDropDownSearch';
import './WithdrawalTransactionsFiltersBar.scss';

const WithdrawalTransactionsFiltersBar = ({
  isLoading,
  isInitialized,
  isDownloadCommissionSystemTransactionsReport,
  filters,
  handleSetFilters,
  handleDownloadWithdrawalTransactionsReport
}) => {
  const i18n = useContext(i18nContext);
  const currentDate = new Date();
  const { constants } = useApplicationContext();

  const transferProviderOptions = Object.keys(PAYMENT_PROVIDER).map((provider) => {
    return {
      key: PAYMENT_PROVIDER[provider].name,
      value: i18n.getMessage('paymentProvider.' + PAYMENT_PROVIDER[provider].name)
    };
  });

  const currencyOptions = constants?.currencies?.map((currency) => {
    return {
      key: currency,
      value: currency
    };
  });

  return (
    <div className={'withdrawal-transactions-filters-wrapper'}>
      <div className={'withdrawal-transactions-actions-wrapper'}>
        <div className={'withdrawal-transactions-date-range-filters-wrapper'}>
          <div>
            <span>{i18n.getMessage('commissions.withdrawalTransactions.filter.from.label')}</span>
            <CustomDatePicker
              onChange={handleSetFilters}
              name={'from'}
              value={filters.from}
              maxDate={filters.to || currentDate}
            />
          </div>
          <div>
            <span>{i18n.getMessage('commissions.withdrawalTransactions.filter.to.label')}</span>
            <CustomDatePicker
              onChange={handleSetFilters}
              name={'to'}
              value={filters.to}
              maxDate={currentDate}
              minDate={filters.from}
            />
          </div>
        </div>
        <div className={'export-withdrawal-transactions-reports-actions-wrapper'}>
          <Button
            className={'withdrawal-transactions-button'}
            size={'medium'}
            type={'primary'}
            onClick={handleDownloadWithdrawalTransactionsReport}
            isDisabled={!isInitialized || isDownloadCommissionSystemTransactionsReport || isLoading}
          >
            {isDownloadCommissionSystemTransactionsReport ? (
              <Loader />
            ) : (
              i18n.getMessage('commissions.withdrawalTransactions.button.downloadReport')
            )}
          </Button>
        </div>
      </div>

      <InputDropDown
        className={'withdrawal-transactions-filter-wrapper'}
        name={'transfer_providers'}
        label={i18n.getMessage('commissions.withdrawalTransactions.filter.transferProvider.label')}
        value={filters.transfer_providers}
        options={transferProviderOptions}
        onChange={handleSetFilters}
        isMulti
      />
      <InputDropDownSearch
        className={'withdrawal-transactions-filter-search-select-wrapper'}
        label={i18n.getMessage('commissions.withdrawalTransactions.filter.currency.label')}
        name={'currencies'}
        value={filters.currencies}
        options={currencyOptions}
        onChange={handleSetFilters}
        isMulti
      />
    </div>
  );
};

WithdrawalTransactionsFiltersBar.propTypes = {
  isLoading: PropTypes.bool,
  isInitialized: PropTypes.bool,
  isDownloadCommissionSystemTransactionsReport: PropTypes.bool,
  filters: PropTypes.object,
  handleSetFilters: PropTypes.func,
  handleDownloadWithdrawalTransactionsReport: PropTypes.func
};

export default WithdrawalTransactionsFiltersBar;
